<script setup lang="ts">
import type { IResponseData } from '~/types'
import { FeaturePagination } from '~/components/feature/pagination'
import { LucideNewspaper } from 'lucide-vue-next'
import { EntityVacancyItem, EntityVacancySkeleton } from '~/components/entity/vacancy'
import type { IVacancy, IVacancyListProps as IProps } from '~/components/entity/vacancy'

const props = defineProps<IProps>()

const route = useRoute()

const page = ref<number>(Number(route.query.page || 1))

const url = computed(() =>
  useUrlWithParams('/vacancies', { ...props.queryParams, page: page.value })
)
const {
  data: vacancies,
  status,
  refresh
} = useApi<IResponseData<IVacancy[]>>(() => computed(() => url.value), {
  key: 'vacancies-list-page'
})
const fetchVacancies = (pageNumber: number) => {
  page.value = pageNumber
  refresh()
}
</script>

<template>
  <div>
    <section v-if="status === 'success'">
      <div v-if="vacancies?.data?.length" class="space-y-3">
        <template v-for="item in vacancies.data" :key="item.id">
          <EntityVacancyItem
            :item="item"
            :hide-organization-details="props.hideOrganizationDetails"
          />
        </template>
        <div class="mt-7 flex justify-end">
          <FeaturePagination
            :meta="vacancies.meta"
            :links="vacancies.links"
            @change="fetchVacancies"
          />
        </div>
      </div>
      <Alert v-else variant="blue">
        <LucideNewspaper />
        <AlertDescription>{{ $t('common.no_open_vacancies') }}</AlertDescription>
      </Alert>
    </section>

    <section v-else>
      <EntityVacancySkeleton
        :count="Number(props.queryParams?.per_page || 3)"
        :hide-organization-details="props.hideOrganizationDetails"
      />
    </section>
  </div>
</template>
